import { jsx as a } from "react/jsx-runtime";
import o from "../../../node_modules/@faststore/components/dist/esm/atoms/Button/Button.js";
const n = ({ handleAddToCart: t }) => /* @__PURE__ */ a(
  o,
  {
    onClick: t,
    "data-button-variant": "primary",
    "aria-label": "adicionado ao carrinho",
    title: "Add to cart Sales",
    className: "product-card-button",
    children: "Adicionar"
  }
);
export {
  n as AddToCartButton
};
